<template>
	<div class="content-wrapper">
		<pageheader title="Users"></pageheader>
		<div class="content">
            <div v-if="isLoaded" class="row">
                <div class="col-md-12">
                    <uiusers ></uiusers>
                </div>
            </div>
            <div v-else>
                <div style="height: 100px">
                    <div class="loader loader-inline no-margin-top"></div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import pageheader from '@components/pages/elements/header'
import uiComponent from '@components/pages/users'

export default {
	name: 'Users',
	components : {
		pageheader,
        'uiusers' : uiComponent.view
	},
	data() {
		return {
            isLoaded : true
		}
	},
	mounted () {
        this.initialize();
    },
	computed : {
        data(){
            return {
            }
        }
	},
	methods : {
        initialize() {
            //this.loadConfig();
        },

    }
}
</script>